







import { Component, Prop, Vue } from 'vue-property-decorator'
import SidebarMenu from '@/components/app/SidebarMenu.vue'

@Component({
  components: { SidebarMenu }
})
export default class Sidebar extends Vue {
  @Prop(Boolean)
  readonly collapsed?: boolean

  onCollapse(collapsed: boolean) {
    this.$emit('update:collapsed', collapsed)
  }
}
